import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpyglass = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 365.4 365.4",
	fill: "#EDFEF6",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", { d: "M98.4,12.9c82.1-34.9,177,3.4,211.9,85.5c34.9,82.1-3.4,177-85.5,211.9c-82.1,34.9-177-3.4-211.9-85.5   C-22,142.7,16.3,47.8,98.4,12.9z M283.9,109.6c-28.7-67.5-106.7-99-174.3-70.3C42.1,68,10.6,146,39.3,213.6   c28.7,67.5,106.7,99,174.3,70.3C281.1,255.2,312.6,177.2,283.9,109.6z" }), /* @__PURE__ */ _jsx("path", { d: "M264.4,264.4c5.6-5.6,14.7-5.6,20.3,0l76.5,76.5c5.6,5.6,5.6,14.7,0,20.3s-14.7,5.6-20.3,0l-76.5-76.5   C258.8,279.1,258.8,270,264.4,264.4z" })] })
});
export { SvgSpyglass as ReactComponent };
